import * as React from "react";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import { Skeleton } from "@mui/material";

const CustomSkeleton = ({
  type = "skeleton",
  height = "100%",
  width = "100%",
  animation = "wave",
  variant = "rounded",
}) => {
  return (
    <Stack spacing={2} sx={{ width: width,height:"100%", color: "grey.500" }}>
      {type === "skeleton" ? (
        <Skeleton
          animation={animation}
          variant={variant}
          width={width}
          height={height}
          sx={{ bgcolor: "grey.200" }}
        />
      ) : (
        <LinearProgress
          sx={{
            height: height,
            bgcolor: "#212A69",
            borderRadius: "25px",
            "& .MuiLinearProgress-bar": {
              bgcolor: "#292168",
              borderRadius: "25px",
            },
          }}
        />
      )}
    </Stack>
  );
};

export default CustomSkeleton;
